import dayjs from 'dayjs';

const MONTHS_PER_YEAR = 12;

export const isSameMonth = (firstDate: Date, secondDate: Date): boolean => {
  return dayjs(firstDate).isSame(secondDate, 'month');
};

export const isMonthBefore = (
  candidateMonth: Date,
  referenceMonth: Date
): boolean => {
  return dayjs(candidateMonth)
    .startOf('month')
    .isBefore(dayjs(referenceMonth).startOf('month'));
};

export const isMonthAfter = (
  candidateMonth: Date,
  referenceMonth: Date
): boolean => {
  return dayjs(candidateMonth)
    .startOf('month')
    .isAfter(dayjs(referenceMonth).startOf('month'));
};

interface IIsMonthDisabledParams {
  candidateMonth: Date;
  minSelectableMonth?: Date;
  maxSelectableMonth?: Date;
}

export const isMonthDisabled = ({
  candidateMonth,
  minSelectableMonth,
  maxSelectableMonth
}: IIsMonthDisabledParams): boolean => {
  if (minSelectableMonth && isMonthBefore(candidateMonth, minSelectableMonth)) {
    return true;
  }
  if (maxSelectableMonth && isMonthAfter(candidateMonth, maxSelectableMonth)) {
    return true;
  }
  return false;
};

export const formatMonthShort = (date: Date): string => {
  return dayjs(date).format('MMM');
};

export const formatMonthYearLong = (date: Date): string => {
  return dayjs(date).format('MMMM YYYY');
};

export const getMonthCellsForYear = (year: number): Date[] => {
  return Array.from({ length: MONTHS_PER_YEAR }, (_, monthIndex) => {
    return new Date(year, monthIndex, 1);
  });
};

interface ICanNavigateToYearParams {
  targetYear: number;
  minSelectableMonth?: Date;
  maxSelectableMonth?: Date;
}

export const canNavigateToYear = ({
  targetYear,
  minSelectableMonth,
  maxSelectableMonth
}: ICanNavigateToYearParams): boolean => {
  const lastMonthOfYear = new Date(targetYear, MONTHS_PER_YEAR - 1, 1);
  const firstMonthOfYear = new Date(targetYear, 0, 1);

  if (
    minSelectableMonth &&
    isMonthBefore(lastMonthOfYear, minSelectableMonth)
  ) {
    return false;
  }
  if (
    maxSelectableMonth &&
    isMonthAfter(firstMonthOfYear, maxSelectableMonth)
  ) {
    return false;
  }
  return true;
};
